<div style="padding: 0;margin: 0">
    <span style="padding: 10px;font-weight: bold">{{title}}
        <button mat-icon-button color="primary"
                [disabled]="form.disabled"
                (click)="openMap()">
            <mat-icon>
                map
            </mat-icon>
        </button>
    </span>
    <mat-card-content>
        <form [formGroup]="form" class="flex-direction-row flex-around-center w100">
            <mat-form-field style="flex: 1;margin: 0 5px" appearance="fill">
                <mat-label>{{'latitude'|translate}}</mat-label>
                <input matInput formControlName="latitude" type="number" [min]="minLat" [max]="maxLat"
                >
            </mat-form-field>
            <mat-form-field style="flex: 1;margin: 0 5px" appearance="fill">
                <mat-label>{{'longitude'|translate}}</mat-label>
                <input matInput formControlName="longitude" type="number" [min]="minLng" [max]="maxLng">
            </mat-form-field>
        </form>
    </mat-card-content>
</div>
